import {  DronePageReducer } from "./redux";
import { droneFeatureApi } from "./redux/api";

export const DroneFeatureMiddlewares = [
  droneFeatureApi.middleware,
];

export const DroneFeatureReducers = {
  DronePageReducer,
  [droneFeatureApi.reducerPath]: droneFeatureApi.reducer,
};
